( function() {
        var e = function(e) {
            this.element = e, this.list = this.element.getElementsByClassName("js-subnav__list")[0], this.content = document.getElementsByClassName("js-subnav-content")[0], this.anchors = this.list.querySelectorAll('a[href^="#"]'), this.sections = function(e) {
                    for (var t = [], i = 0; i < e.anchors.length; i++) {
                        var s = document.getElementById(e.anchors[i].getAttribute("href").replace("#", ""));
                        s && t.push(s)
                    }
                    return t
                }(this), this.clickScrolling = !1, this.intervalID = !1,
                function(e) {
                    e.list.addEventListener("click", (function(i) {
                        var s = i.target.closest('a[href^="#"]');
                        s && (e.clickScrolling = !0, t(e, s))
                    }));
                    for (var i = new IntersectionObserver((function(i, s) {
                            i.forEach((function(i) {
                                e.clickScrolling || function(e) {
                                    e.intervalID && clearInterval(e.intervalID);
                                    e.intervalID = setTimeout((function() {
                                        for (var i = window.innerHeight / 2, s = -1, n = 0; n < e.sections.length; n++) {
                                            e.sections[n].getBoundingClientRect().top < i && (s = n)
                                        }
                                        s > -1 && t(e, e.anchors[s]), e.intervalID = !1
                                    }), 100)
                                }(e)
                            }))
                        }), {
                            threshold: [0, .1],
                            rootMargin: "0px 0px -70% 0px"
                        }), s = 0; s < e.sections.length; s++) i.observe(e.sections[s]);
                    e.element.addEventListener("subnav-scroll", (function(t) {
                        e.clickScrolling = !1
                    }))
                }(this)
        };

        function t(e, t) {
            if (t) {
                for (var i = 0; i < e.anchors.length; i++) Util.removeClass(e.anchors[i], "subnav__link--selected");
                Util.addClass(t, "subnav__link--selected")
            }
        }
        var i = document.getElementsByClassName("js-subnav"),
            s = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype,
            n = [];
        if (i.length > 0 && s) {
            for (var a = 0; a < i.length; a++) ! function(t) {
                n.push(new e(i[t]))
            }(a);
            var r = !1,
                o = new CustomEvent("subnav-scroll");

            function l() {
                for (var e = 0; e < n.length; e++) ! function(e) {
                    n[e].element.dispatchEvent(o)
                }(e)
            }
            window.addEventListener("scroll", (function() {
                clearTimeout(r), r = setTimeout(l, 100)
            }))
        }
    })();


